import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
export default class WorkdocActMaintenance extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      products: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/act/maintenance/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });
    let products = await this.context.api.qa("/act/maintenance/item/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });
    this.setState({ pending: false, items, products });
  };
  render() {
    const { items, products, pending } = this.state;
    const document = this.props.document || {};
    return (
      <>
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            <div>
              Судно: <span className="text-muted">{document.shipname}</span>
            </div>

            {document.description && (
              <div>
                Комментарий:{" "}
                <span className="text-muted">{document.description}</span>
              </div>
            )}
          </div>
          <table className="table">
            <thead>
              <tr>
                <td>Оборудование</td>
                <td>ТО</td>
              </tr>
            </thead>
            <tbody>
              {items.map((line) => {
                let item = line || {};
                let element = item.element || {};
                let maintenance = item.maintenance || {};
                return (
                  <React.Fragment key={item.itemid}>
                    <tr>
                      <td width="50%">
                        {element.label}{" "}
                        <div className="small text-muted">
                          {element.modelname}
                        </div>
                      </td>
                      <td width="50%">
                        {maintenance.label}{" "}
                        <div className="small text-muted">
                          {maintenance.description}
                        </div>
                      </td>
                    </tr>
                    {item.description && (
                      <tr>
                        <td colSpan={10} className="pl-5 small text-muted ">
                          {item.description}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          <hr />
          <table className="table mt-5 pt-4">
            <thead>
              <tr>
                <th>Использованные запасы</th>
                <th>Кол-во</th>
                <th>Ед. изм.</th>
              </tr>
            </thead>
            <tbody>
              {products.map((line) => {
                let item = line || {};
                let model = item.model || {};
                let measure = item.measure || {};
                return (
                  <React.Fragment key={item.itemid}>
                    <tr>
                      <td width="50%">{model.name}</td>

                      <td className="text-nowrap">{item.volume} </td>
                      <td className="text-nowrap">{measure.name}</td>
                    </tr>
                    {item.description && (
                      <tr>
                        <td colSpan={10} className="pl-5 small text-muted ">
                          {item.description}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Blocker>
      </>
    );
  }
}
